import React from 'react'
import { Link } from 'react-router-dom'

export default function TrainingMastery({ data }) {
  return (
    <section className="training-mastery">
      <div className="mastery-bg" style={{ backgroundImage: `url(${data?.bgImage})`, }}>
        <div className="row">
          <div className="col-sm-12 col-md-10 col-lg-5">
            <div className="mastery-text">
              <h3 className="heading">
                {data?.headingLine1} <br />
                {data?.headingLine2}
              </h3>
              <p>{data?.description}</p>
              <div className="btn-sec">
                <Link className="default-btn" to={data?.buttonLink || "/"}>
                  <span>{data?.buttonText}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}